// 获取cookies
export const getCookie = (name: string) => {
  let arr; const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  if (arr === document.cookie.match(reg)) {
    return (arr[2]);
  }
  return null;
};

// 删除cookies
export const delCookie = (name: string) => {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = getCookie(name);
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()};path=/`;
  }
};

// 获取文件大小格式
export const getFileSizeDesc = (size: number) => {
  console.log('size =>', size);
  if (!size) { return ''; }

  const num = 1024.00; // byte

  if (size < num) { return `${size}B`; }
  if (size < Math.pow(num, 2)) { return `${(size / num).toFixed(2)}K`; } // kb
  if (size < Math.pow(num, 3)) { return `${(size / Math.pow(num, 2)).toFixed(2)}M`; } // M
  if (size < Math.pow(num, 4)) { return `${(size / Math.pow(num, 3)).toFixed(2)}G`; } // G
  return `${(size / Math.pow(num, 4)).toFixed(2)}T`; // T
};
